import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './style/style.css';
import mixpanel from 'mixpanel-browser';

const container = document.getElementById('root');
const root = createRoot(container);

mixpanel.init(
	process.env.REACT_APP_MIXPANEL_TOKEN,
	{
		debug: process.env.NODE_ENV === 'development',
		track_pageview: "url-with-path",
		persistence: 'localStorage',
		ignore_dnt: true,
	}
);

// <React.StrictMode /> has been removed to resolve invoking rendering twice (create double http request as well). Add back to if you want to debug. 
root.render(
	<Provider store={store}>
		<App />
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
